


import {
  pushLocation,
  resolvePath,
} from "../router.js";



class RouteLink extends HTMLElement {
  #linkElem;
  #queryArgs = null;

  static get observedAttributes() { return ["to"]; }

  constructor()
  {
    super();

    const shadowRoot = this.attachShadow({ mode: "open" });
  }

  connectedCallback()
  {
    this.#linkElem = document.createElement("a");
    this.#linkElem.style.textDecoration = "none";
    this.#linkElem.style.color = "var(--color)";
    this.#linkElem.appendChild(document.createElement("slot"));

    const path = this.getAttribute("to");
    this.#updateHref(path);

    this.shadowRoot.appendChild(this.#linkElem);
    this.#linkElem.addEventListener("click", this.#onClick);
  }

  disconnectedCallback()
  {
    this.#linkElem.remove();
  }

  attributeChangedCallback(name, oldValue, newValue)
  {
    if (name === "to") {
      this.#updateHref(newValue);
    }
  }

  set queryArgs(args)
  {
    if (this.#queryArgs?.toString() === args?.toString()) { return; }

    this.#queryArgs = args;
    this.#updateHref(this.getAttribute("to"));
  }

  #updateHref = (path) => {
    if (!this.#linkElem) { return; }
    if (path === null) { return; }
    if (path[0] === "/") {
      this.#linkElem.href = resolvePath(null, path, this.#queryArgs);
    } else {
      this.#linkElem.href = resolvePath(this, path, this.#queryArgs);
    }
  }

  #onClick = ev => {
    ev.preventDefault();
    const path = this.getAttribute("to");
    if (!path) { return; }

    const state = this.getAttribute("state");

    if (path[0] === "/") {
      pushLocation(null, path, state, this.#queryArgs);
    } else {
      pushLocation(this, path, state, this.#queryArgs);
    }
  }
}

customElements.define("route-link", RouteLink);
